import { apiHelper } from "@/utils";
import { API } from "@/constants";

const API_URL = `${API.BASE_URL_API}/v1`;
export const productService = {
  getAll,
  store,
  show,
  update,
  updateStatus,
  softDelete,
};

export function getAll(filter = {}) {
  const params = { page: filter.pageNumber, size: filter.pageSize };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(API_URL).get("/products", { params });
}

export function productFormData(data, isUpdate = false) {
  const form = new FormData();
  const fields = {
    name: data.name,
    description: data.description,
    category_uuid: data.categoryUUID,
    condition_uuid: data.conditionUUID,
    pic_company_uuid: data.companyUUID,
    pic_user_uuid: data.picUserUUID,
    listing_end_date: (data.listingEndDate || "").replace("T", " "),
    expiry_date: data.expiryDate || "",
    is_active: data.isActive ? 1 : 0,
  };
  Object.entries(fields).forEach(([key, value]) => form.append(key, value));
  (data.variations || []).forEach((variation, index) => {
    const prefix = `product_variations[${index}]`;
    if (isUpdate && variation.uuid)
      form.append(`${prefix}[uuid]`, variation.uuid);
    form.append(`${prefix}[name]`, variation.name.trim());
    // Multipart has no native null value; an empty nullable field represents unlimited stock.
    form.append(
      `${prefix}[stock]`,
      variation.stock === null ? "" : variation.stock,
    );
    form.append(`${prefix}[cost_price]`, variation.cost_price);
    form.append(`${prefix}[selling_price]`, variation.selling_price);
    form.append(`${prefix}[is_active]`, variation.is_active ? 1 : 0);
  });
  (data.tags || []).forEach((tag, index) => form.append(`tags[${index}]`, tag));
  const images = data.images || [];
  const coverIndex = data.coverImageUUID
    ? null
    : data.coverImageIndex ?? (isUpdate ? null : 0);
  if (
    images.length &&
    coverIndex !== null &&
    (!Number.isInteger(coverIndex) ||
      coverIndex < 0 ||
      coverIndex >= images.length)
  ) {
    throw new Error("Invalid cover image selection.");
  }
  const retainedImages = isUpdate
    ? (data.productImages || []).filter(
        (image) => !(data.deletedImageUUIDs || []).includes(image.uuid),
      )
    : [];
  if (
    data.coverImageUUID &&
    !retainedImages.some((image) => image.uuid === data.coverImageUUID)
  ) {
    throw new Error("Invalid cover image selection.");
  }
  retainedImages.forEach((image, index) => {
    form.append(`images[${index}][uuid]`, image.uuid);
    const selected = data.coverImageUUID
      ? image.uuid === data.coverImageUUID
      : coverIndex === null && [true, 1, "1"].includes(image.is_cover_image);
    form.append(`images[${index}][is_cover_image]`, selected ? 1 : 0);
  });
  images.forEach((image, index) => {
    const position = retainedImages.length + index;
    form.append(`images[${position}][file]`, image);
    form.append(
      `images[${position}][is_cover_image]`,
      index === coverIndex ? 1 : 0,
    );
  });
  if (isUpdate) {
    form.append("_method", "PUT");
    (data.deletedImageUUIDs || []).forEach((uuid, index) =>
      form.append(`deleted_image_uuids[${index}]`, uuid),
    );
    form.append("remove_pdf", data.removePdf ? 1 : 0);
  }
  if (data.pdf instanceof File && !data.removePdf)
    form.append("pdf_url", data.pdf);
  return form;
}

export function store(data) {
  return apiHelper(API_URL).post("/products", productFormData(data));
}
export function show(uuid) {
  return apiHelper(API_URL).get(`/products/${uuid}`);
}
export function update(data) {
  return apiHelper(API_URL).post(
    `/products/${data.uuid}`,
    productFormData(data, true),
  );
}
export function updateStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/products/${uuid}/status`, {
    is_active: isActive ? 1 : 0,
  });
}
export function softDelete(uuid) {
  return apiHelper(API_URL).patch(`/products/delete/${uuid}`);
}
